import { z } from "zod";

export const PersonName = z.object({
  first_name: z.string().nullable(),
  middle_name: z.string().nullable(),
  last_name: z.string().nullable(),
});
export type PersonName = z.infer<typeof PersonName>;

export const DateOfBirth = z.object({
  year: z.number().gt(1700).lt(2500),
  month: z.number().gte(1).lte(12),
  day: z.number().gte(1).lte(31),
});
export type DateOfBirth = z.infer<typeof DateOfBirth>;

export const UpdatePersonName = z.object({
  first_name: z.string().nullish(),
  middle_name: z.string().nullish(),
  last_name: z.string().nullish(),
});
export type UpdatePersonName = z.infer<typeof UpdatePersonName>;

export const PhoneNumber = z.object({ isd: z.string(), number: z.string() });
export type PhoneNumber = z.infer<typeof PhoneNumber>;

export const Gender = z.enum(["Male", "Female"]);
export type Gender = z.infer<typeof Gender>;

export const ContactAddress = z.object({
  address_line_1: z.string().nullable(),
  suburb: z.string().nullable(),
  city: z.string().nullable(),
  postcode: z.string().nullable(),
  province: z.string().nullable(),
  country_code: z.string().nullable(),
});
export type ContactAddress = z.infer<typeof ContactAddress>;

export const Identification = z.object({
  // use this to update?!?!
  type_id: z.number().nullish(),
  // use this for get?!?!
  id_type_id: z.number().nullish(),
  number: z.string().nullable(),
  expiry_date: z.string().nullable(),
  issue_date: z.string().nullable(),
  country_code: z.string().nullable(),
  temporary_residence_visa_number: z.string().nullish(),
});
export type Identification = z.infer<typeof Identification>;

export const TradeAbility = z.enum(["Buy", "Sell"]);
export type TradeAbility = z.infer<typeof TradeAbility>;

export const Currency = z.object({
  id: z.number(),
  name: z.string(),
  currency_code: z.string(),
});
export type Currency = z.infer<typeof Currency>;
